import type { FaireReviewEntity } from "../../entity_types/review";

export const review_r3: FaireReviewEntity = {
  token: "review_r3",
  type: "review",
  brandName: "ROEN",
  reviewerName: "Emily R.",
  reviewerLocation: "Austin, TX",
  stars: 4,
  reviewText:
    "Great product overall. Shipping was fast and the candles arrived in perfect condition. Would love to see more seasonal scents.",
  reviewDate: "Dec 22, 2025",
  reviewType: "brand",
  purchasedProductImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/a15d1fc087908754991b018a69774258782ff3fad6f50ef4078fe96c26a1caf6.webp",
    "https://cdn.prerelease.faire.dev/fastly/59a4005712dbc289690cccb048ed1838bfbb32630127b5ae4ce805f9204e0b93.webp",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
